var exports = {
  "s": "bordered-Y0h5d",
  "U": "flex-Y0h5d",
};

module.exports = exports;
